import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';

export const roleGuard: CanActivateFn = async (route, state) => {
  const router = inject(Router);
  const expectedRoles = route.data?.['roles'] as Array<string>;

  try {
    const session = await fetchAuthSession();
    const tokens = session.tokens;
    if (!tokens)return router.createUrlTree(['/']);
    const groups = (tokens.accessToken.payload['cognito:groups'] as string[]) || [];
    const hasRole = expectedRoles.some(role => groups.includes(role));
    if (hasRole) return true; 
    else return router.createUrlTree(['/']); 
  } catch (error) {
    console.error('Auth Guard Error', error);
    return router.createUrlTree(['/']);
  }
};